import { Link, Route, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  AppBar as MuiAppBar,
  Hidden,
  Toolbar,
  Typography,
  IconButton,
  Icon,
} from '@material-ui/core';

import { remove } from 'communication/httpClient';
import { ModulesNavigation } from 'components/Layout';

import useStyles from './style';

import Logo from './logo.svg';
import SearchBar from '../../SearchBar';

const AppBar = (props) => {
  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation();

  const handleHomeRedirect = () => {
    history.push('/');
  };

  const doLogout = () => {
    props.setLoggedIn(false);
    history.push('/');
  };

  const handleLogout = async () => {
    await remove('/api/principal');
    doLogout();
  };

  return (
    <MuiAppBar position="sticky">
      <Toolbar className={classes.toolbar}>
        <div className={classes.titleWrapper}>
          <Link to="/" className={classes.link} onClick={() => handleHomeRedirect()}>
            <img src={Logo} className={classes.logo} alt="Logo" />
          </Link>
          <Typography variant="h6" className={classes.title} data-testid="title">
            {t('title.websiteName')}
          </Typography>
        </div>
        <SearchBar />
        <div className={classes.accountWrapper}>
          <IconButton onClick={handleLogout} className={classes.iconButton}>
            <Icon className={classes.icon}>account_circle</Icon>
          </IconButton>
        </div>
      </Toolbar>
      <Hidden implementation="css" xsDown>
        <Route
          path="/(branding|cash-office|catalog|operations|organization|sales|utilities)"
          component={ModulesNavigation}
        />
      </Hidden>
    </MuiAppBar>
  );
};

export default AppBar;
